import { JournalRepository } from "../../domain/repositories/JournalRepository";
import {
  DuplicateJournalResultEntity,
  JournalCountsEntity,
  JournalListStatus,
  JournalsResultEntity,
} from "../../domain/entities/JournalEntity";
import {
  duplicateJournal,
  fetchJournalCounts,
  fetchJournals,
} from "../api/journalsApi";
import { JournalMapper } from "../mappers/JournalMapper";

export class JournalRepositoryImpl implements JournalRepository {
  async fetchJournals(params?: {
    limit?: number;
    offset?: number;
    status?: JournalListStatus;
    search?: string;
    date_from?: string;
    date_to?: string;
    sort_by?:
      | "created_at"
      | "updated_at"
      | "date"
      | "approved_at"
      | "journal_number";
    sort_order?: "asc" | "desc";
  }): Promise<JournalsResultEntity> {
    const response = await fetchJournals(params);
    return JournalMapper.toJournalsResultEntity(response);
  }

  async fetchJournalCounts(params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<JournalCountsEntity> {
    const response = await fetchJournalCounts(params);
    return JournalMapper.toJournalCountsEntity(response);
  }

  async duplicateJournal(
    journalId: number,
  ): Promise<DuplicateJournalResultEntity> {
    const response = await duplicateJournal(journalId);
    return JournalMapper.toDuplicateJournalResultEntity(response);
  }
}
